import Rx from 'rxjs';
import moment from 'moment';
import Raven from 'raven-js';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';
import { delay } from 'rxjs/operators';

import { env_production } from 'core/constants';
import * as generalFunctions from 'core/generalFunctions';
import * as constAction from 'root/actionConstants';
import * as userActions from 'modules/user/action';
import * as generalActions from 'modules/general/action';
import * as reservasActions from 'modules/reservas/action';
import * as errorActions from 'modules/error/action';
import * as reportesActions from 'modules/reportes/action';
import * as usersActions from 'modules/user/action';
import * as gruposSolicitudesActions from 'modules/gruposSolicitudes/action';

import { coreUrl } from 'core/constants';

const { ajax } = Rx.Observable;

const getRolesEpic = (action$, store) =>
  action$.ofType(constAction.USER_GET_ROLES).mergeMap((action) =>
    ajax(generalFunctions.request(action))
      .map(({ response }) => userActions.setState({ roles: response && response.roles }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

const getUserDataEpic = (action$, store) =>
  action$.ofType(constAction.USER_GET_DATA).mergeMap((action) =>
    ajax(generalFunctions.request(action))
      .mergeMap(({ response }) => [userActions.setState(response), userActions.loginStorage(response), push('/dashboard/reservas/main')])
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

const logoutEpic = (action$) =>
  action$.ofType(constAction.USER_LOGOUT).switchMap(() => {
    generalFunctions.logout();
    generalFunctions.deleteCookie('at');
    window.location.assign(`${coreUrl}/exit/logout`);
    return Rx.Observable.empty();
  });

const checkLoginEpic = (action$, store) =>
  action$
    .ofType(constAction.USER_CHECK_LOGIN)
    .take(1)
    .mergeMap(() => {
      let access_token = localStorage.getItem('access_token'),
        userId = localStorage.getItem('userId'),
        nombre = localStorage.getItem('nombre'),
        apellido = localStorage.getItem('apellido'),
        roles = JSON.parse(localStorage.getItem('roles'));

      if (!access_token) access_token = generalFunctions.getCookie('at');
      if (!access_token) access_token = localStorage.getItem('accessToken');

      if (access_token) {
        const actions = [];

        if (!userId) {
          actions.push(userActions.setState({ access_token }));
          actions.push(userActions.getUserData());
        } else {
          Raven.setUserContext({ userId, nombre, apellido });
          actions.push(userActions.setState({ access_token, userId, nombre, apellido, roles: roles || [] }));
        }
        // Acciones apenas ingresa
        actions.push(userActions.getRoles());
        actions.push(generalActions.startSockets());
        //actions.push(reportesActions.getReportes(false, moment().toISOString(), true, 0));
        //actions.push(gruposSolicitudesActions.getGruposSolicitudes());
        //actions.push(reservasActions.getReservasPendientes());
        //actions.push(gruposSolicitudesActions.getCantidadGruposSolicitudes());
        let currentPath = generalFunctions.getCurrentPath(store);
        if (currentPath == '/dashboard' || currentPath == '/' || !currentPath) actions.push(push('/dashboard/reservas/main'));
        return Rx.Observable.merge(actions);
      } else {
        alert('Necesitas estar logueado para utilizar el sistema.');
        //if (env_production) return Rx.Observable.of(usersActions.logout()).pipe(delay(3000));
        //else
        return Rx.Observable.empty();
      }
    })
    .catch((err) => {
      console.log('err', err);
      return Rx.Observable.empty();
    });

export const setStorageLoginEpic = (action$, store) =>
  action$.ofType(constAction.USER_SET_STORAGE).mergeMap((action) => {
    if (action.payload.access_token || action.payload.id) localStorage.setItem('access_token', action.payload.access_token || action.payload.id);
    if (action.payload.userId) {
      Raven.setUserContext({ userId: action.payload.userId });
      localStorage.setItem('userId', action.payload.userId);
    }
    if (action.payload.nombre) {
      Raven.setUserContext({ nombre: action.payload.nombre });
      localStorage.setItem('nombre', action.payload.nombre);
    }
    if (action.payload.apellido) {
      Raven.setUserContext({ apellido: action.payload.apellido });
      localStorage.setItem('apellido', action.payload.apellido);
    }
    if (action.payload.roles) {
      Raven.setUserContext({ roles: action.payload.roles });
      localStorage.setItem('roles', JSON.stringify(action.payload.roles));
    }
    if (!env_production) console.log('access_token', action.payload.id);
    const currentPath = generalFunctions.getCurrentPath(store);
    return currentPath == '/dashboard' || currentPath == '/' ? Rx.Observable.of(push('/dashboard/reservas/main')) : Rx.Observable.empty();
  });

export default combineEpics(getRolesEpic, logoutEpic, checkLoginEpic, setStorageLoginEpic, getUserDataEpic);



// WEBPACK FOOTER //
// src/modules/user/epics.js